<template lang="html">
  <div class="stages" v-show="goal.id">
    <HeadedContainer padded>

      <template v-slot:header>
        <div class="header">
          <span>
            <span class="top-label">{{$ml.get(`NUTRIENTS REQUIREMENTS,`)}}</span>
            <div class="units-selector" v-if="$store.getters['crop/base'].type == 'soil-grown'">
              <span class="tip" :class="{selected: selectedUnit === $store.getters['unit/getLabel']('kg/ha')}" @click="selectedUnit = $store.getters['unit/getLabel']('kg/ha')">
                {{$ml.get($store.getters['unit/getLabel']('kg/ha'))}}
              </span>
              <span class="tip" :class="{selected: selectedUnit === 'ppm'}" @click="selectedUnit = 'ppm'">
                {{$ml.get($store.getters['unit/getLabel']('ppm'))}}
              </span>
            </div> 
            <span class="tip" v-else>ppm</span>
          </span>
          <AddBtn @click="openCreate" v-if="$store.getters['crop/base'].owner != 0"/>
        </div>
      </template>

      <transition name="modal-fade-scale">
        <StagesCreate
          v-if="is_creating"
          @close="closeCreate"
          @update="sync"
        />
      </transition>
      <transition name="modal-fade-scale">
        <StagesEdit
          v-if="is_edit"
          :item="editing"
          @close="closeEdit"
          @update="sync"
        />
      </transition>

      <div v-if="stages && stages.length" class="body" :class="{blur : (!$store.getters['user/data'].subsPlan)}">

        <app-btn to="/dashboard/plans" class="go-to-plans" v-if="!$store.getters['user/data'].subsPlan">{{$ml.get(`Get the full access to the software`)}}</app-btn>

        <div class="table">
          <StagesItem
            v-for="item in stages"
            :unit="selectedUnit"
            :data="item"
            @edit="openEdit(item)"
            @remove="remove(item)"
          />
        </div>
      </div>
      <div v-else class="no-data">
        {{ $ml.get(`No stages`) }}
      </div>
    </HeadedContainer>

  </div>
</template>

<script>
import API from '@/api';
import StagesItem from './StagesItem';
import HeadedContainer from '@/components/common/HeadedContainer';
import { mapGetters } from 'vuex';
import AddBtn from './AddBtn';
import EditBtn from './EditBtn';
import StagesCreate from './StagesCreate';
import StagesEdit from './StagesEdit';
// import MoreActions from './MoreActions';

export default {

  components: {
    StagesItem,
    HeadedContainer,
    AddBtn,
    EditBtn,
    StagesCreate,
    StagesEdit,
    // MoreActions
  },

  computed: {
    ...mapGetters({
      stages: 'crop/stages',
      goal: 'crop/goal',
    })
  },

  data() {
    return {
      is_creating: false,
      is_edit: false,
      editing: {},
      selectedUnit: ''
    };
  },
  mounted() {
    this.selectedUnit = this.$store.getters['unit/getLabel']('kg/ha')
  },
  methods: {
    remove(item) {
      return API.crop.deleteCropStage(item.id).then(res => {
        this.sync();
      });
    },

    openCreate() {
      this.is_creating = true;
    },
    closeCreate() {
      this.is_creating = false;
    },


    openEdit(item) {
      this.editing = item;
      this.is_edit = true;
    },
    closeEdit() {
      this.is_edit = false;
    },


    // save(item) {
    //   API.crop.createCropStage(this.new).then(res => {

    //   });
    // },


    // delete(item) {
    //   API.crop.createCropStage(this.new).then(res => {

    //   });
    // },


    sync() {
      
      return this.$store.dispatch('crop/updateStages').finally(() => {

      });

      
    },
  }

}
</script>

<style lang="scss" scoped>
.top-label {
  margin-right: 6px;
}
.stages {
  flex-grow: 1;
  min-height: 200px;

  display: flex;
  flex-direction: row;
  align-items: stretch;

  .headed-container {
    width: 100%;
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    width: 100%;
  }
  .units-selector {
    display: inline-block;
    .tip {
    padding: 5px 0 4px;
    border: 2px #2678d4 solid;
    text-transform: none;
    opacity: .6;
    &:hover {
      cursor: pointer;
    }
    &.selected {
      padding: 3px 5px;
      border: 2px #2578D4 solid;
      border-radius: 8px;
      color: #2578D4;
      background: #fff;
      opacity: 1;
    }
  }
  }

  .tip {
    text-transform: lowercase;
  }
  

  .main-title {
    color: $mainGreen;
    font-size: 16px;
    font-weight: bold;
  }

  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;

    color: #ddd;
    flex-grow: 1;
    padding: 30px 0;
    width: 100%;
    height: 100%;
  }

  .body {
    display: flex;
    align-items: stretch;
    flex-direction: column;

    width: 100%;
    position: relative;


  }
  @media (max-width: 768px) {
    .headed-container.padded {
      .body {
        padding: 16px 12px;
      }
    }
  }
}

</style>
